import api from '@/api/api' //引入接口
export default {
	state: {
		uploadMemeNum: 0, //上传表情包列表的数量
		uploadMusicNum: 0, //上传音乐列表的数量
		uploadZhiKNum: 0, //发蜘客的列表数量
		upDateMessageNum: 0, //私信的列表数量
		upDateGroupNum: 0, //群组(秘书台)消息未读数量
		updateGroupStatus: true, //刷新群组(秘书台)列表 
		upDateEmailNum: 0, //邮箱的列表数量
	},
	//更新数量
	mutations: {
		upDateNum(state, status) {
			if (status.path == "上传表情") {
				// state.uploadMemeNum = status.num
			}
			if (status.path == "上传音乐") {
				// state.uploadMusicNum = status.num
			}
			if (status.path == "发蜘客") {
				// state.uploadZhiKNum = status.num
			}
			if (status.path == "私信") {
				state.upDateMessageNum = status.num
			}
			if (status.path == "邮箱") {
				state.upDateEmailNum = status.num
			}
		},
		//改变秘书台未读数 一个群组有未读 只计为1
		updateGroumNum(state, newVal) {
			state.upDateGroupNum = newVal
		},
		//刷新群组列表 用一个布尔值来判断 比较容易用watch监听
		changeGroupList(state, newVal) {
			console.log('Vuex: changeGroupList被调用，当前状态:', state.updateGroupStatus, '新值:', newVal);
			state.updateGroupStatus = !state.updateGroupStatus;
			console.log('Vuex: updateGroupStatus更新为:', state.updateGroupStatus);
		},
	},
	actions: {
		//改变数量 上传表情 上传音乐 发蜘客 邮箱
		changeNum(state, status) {
			//判断上传表情
			if (status == "上传表情") {
				return new Promise((resolve, reject) => {
					api.other.queryUploadPageList().then(res => {
						state.commit('upDateNum', {
							path: status,
							num: res.result.total
						})
						resolve(res.result.total)
					})
				})
			}
			//判断上传音乐
			if (status == "上传音乐") {
				return new Promise((resolve, reject) => {
					api.upload.getUploadMusicList().then(res => {
						state.commit('upDateNum', {
							path: status,
							num: res.result.total
						})
						resolve(res.result.total)
					})
				})
			}
			//判断发蜘客
			if (status == "发蜘客") {
				return new Promise((resolve, reject) => {
					let num = 0
					//草稿列表
					api.article.articleList({
						status: 0
					}).then(res => {
						num += res.result.total
						//已发列表
						api.article.articleList({
							status: 1
						}).then(resI => {
							num += resI.result.total
							//垃圾箱列表
							api.article.rubbishList().then(resII => {
								num += resII.result.total
								state.commit('upDateNum', {
									path: status,
									num
								})
								resolve(num)
							})
						})
					})
				})
			}

			//判断发邮箱
			if (status == "邮箱") {
				return new Promise((resolve, reject) => {
					api.email.emailStaticsList().then(res => {
						state.commit('upDateNum', {
							path: status,
							num: res.result.unread
						})
						resolve(res.result.unread)
					})
				})
			}
		},
		//监听私信消息 融云私信的消息的数量不准确
		changeMSg(state, status) {
			//判断私信
			if (status.path == "私信") {
				state.commit('upDateNum', {
					path: status.path,
					num: status.num
				})
			}
		},
		//改变融云的私信数量 因为这个需要把this传过来 所以和别的分开
		changeMsgNum(state, newVal) {
			return new Promise((resolve, reject) => {
				console.log('newVal:', newVal); // 调试输出
				// setTimeout(() => {
					// 是否包含免打扰
					const isIncludeNotNotification = false
					console.log('newVal.RongIMClient:', newVal.RongIMClient);
					
					newVal.RongIMClient.Tag.get('0').then(tag => {

						tag.getConversationList(0, 1000).then(conversationList => {
							if (!conversationList.code) {
								// 过滤出私聊类型的会话
								const privateConversations = conversationList.filter(item => 
									item.conversationType === 1
								);
								
								// 获取当前正在聊天的目标ID，如果用户正在与某人聊天，则不将该人的未读消息计入总数
								const currentChatTargetId = newVal.$store.state.rongyun.targetId;
								
								// 并行检查每个会话的好友状态
								const checkPromises = privateConversations.map(async (conversation) => {
									try {
										const res = await newVal.$api.userMsg.userDetail(conversation.targetId);
										// 只有是好友且不在黑名单的会话才计入未读数
										if (res.result && res.result.friendFlag == 1 && res.result.blacklistFlag == 0) {
											// return conversation.unreadMessageCount || 0;
											// 如果当前正在与该用户聊天，则未读消息数设为0，否则使用实际未读数
											return currentChatTargetId == conversation.targetId ? 0 : conversation.unreadMessageCount || 0;
										}
										return 0;
									} catch (error) {
										console.error('获取用户详情失败:', error);
										return 0;
									}
								});
								
								// 等待所有检查完成并计算总未读数
								Promise.all(checkPromises).then(counts => {
									const totalUnreadCount = counts.reduce((sum, count) => sum + count, 0);
									console.log('计算后的好友未读消息数:', totalUnreadCount);
									
									let obj = {}
									obj.path = "私信"
									obj.num = totalUnreadCount
									state.commit('upDateNum', obj)
									resolve(totalUnreadCount)
								});
							}
						});	
						// tag.getUnreadCount(isIncludeNotNotification).then(result => {
						// 	console.log('getUnreadCount result:', result); // 调试输出
						// 	// 获取未读消息数
						// 	if (!result.code) {
						// 		//console.log('标签会话未读数', result);
						// 		let obj = {}
						// 		obj.path = "私信"
						// 		obj.num = result
						// 		state.commit('upDateNum', obj)
						// 		resolve(result)
						// 	}
						// });
					});
				// }, 100)
			})
		},
		//改变融云的私信数量 因为这个需要把this传过来 所以和别的分开
		changeGroupMsgNum(state, newVal) {
			return new Promise((resolve, reject) => {
				setTimeout(() => {
					let conversationTypes = [RongIMLib.CONVERSATION_TYPE.GROUP];
					newVal.RongIMClient.Conversation.getTotalUnreadCount(
						false,
						conversationTypes
					).then((totalUnreadCount) => {
						console.log("======", totalUnreadCount)
						let obj = {}
						obj.path = "群组"
						obj.num = totalUnreadCount
						state.commit('upDateNum', obj)
						resolve(totalUnreadCount)
					});
				}, 100)
			})
		},
		//改变秘书台群组的消息角标数量 要传一个this过来
		actionChangeGroup(state, newVal) {
			//  类型 0默认群聊 1会议 2活动 3婚礼4宴席5殡礼6庆典7生日会
			let arr = [0, 1, 2, 3, 4, 5, 6, 7]
			let countAll = 0
			let promises = []
			
			arr.forEach(item => {
				const promise = newVal.$api.group.groupGroupInfoList(item).then((res) => {
					//设置子列表
					const groupPromises = res.result.map((p) => {
						if (p.isAdmin !== 1 && p.memberId !== newVal.loginMsg.memberId) {
							//获取消息列表当前的未读数
							try {
								let conversation = newVal.RongIMClient.Conversation.get({
									targetId: p.id,
									type: window.RongIMLib.CONVERSATION_TYPE.GROUP,
								});
								
								if (!conversation || typeof conversation.getUnreadCount !== 'function') {
									console.error(`获取群组 ${p.id} 会话对象无效或缺少 getUnreadCount 方法`);
									return Promise.resolve(0);
								}
								
								return conversation.getUnreadCount().then((count) => {
									// console.log("获取指定会话未读数成功", count);
									if (count > 0) {
										countAll += 1
									}
								}).catch(error => {
									console.error(`获取群组 ${p.id} 未读数失败:`, error);
									return 0;
								});
							} catch (error) {
								console.error(`获取群组 ${p.id} 会话对象失败:`, error);
								return Promise.resolve(0);
							}
						} else {
							return Promise.resolve(0);
						}
					});
					
					return Promise.all(groupPromises);
				});
				promises.push(promise)
			})
			
			//等待所有请求完成后再赋值
			Promise.all(promises).then(() => {
				console.log("vuex中的count", countAll)
				state.commit('updateGroumNum', countAll)
			})
		}
	},
	getters: {}
}